import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { INotificationRecipientSelection } from '../models/id-comment.model';

export class CommentForm extends FormGroup {
  readonly id = this.get('id') as FormControl<string>;
  readonly comment = this.get('comment') as FormControl<string>;
  readonly useCustomRecipients = this.get('useCustomRecipients') as FormControl<boolean>;
  readonly customNotificationRecipients = this.get('customNotificationRecipients') as FormControl<
    INotificationRecipientSelection[]
  >;

  constructor(
    id: string,
    readonly fb: FormBuilder = new FormBuilder()
  ) {
    super(
      fb.group({
        id: id || '',
        comment: ['', Validators.required],
        useCustomRecipients: [false],
        customNotificationRecipients: [[]],
      }).controls
    );
  }
}
